import React, { useRef } from 'react';

import ReactSignature from '@uiw/react-signature';

export function Signature({ pushEventTo, value, onChange, target, readonly }) {
  const $svg = useRef(null);
  const targetEl = document.getElementById(target);

  const clear = event => {
    $svg.current?.clear();
    pushEventTo(targetEl, onChange, { value: [] });
  };
  const onEndStroke = data => {
    if (data.length > 0) {
      value = value || [];
      const newPoints = [...value, data];
      pushEventTo(targetEl, onChange, { value: newPoints });
    }
  };

  return (
    <>
      <ReactSignature
        options={{
          size: 6,
          smoothing: 0.46,
          thinning: 0.73,
          streamline: 0.5,
        }}
        readonly={readonly}
        defaultPoints={value || []}
        onPointer={onEndStroke}
        style={{ '--w-signature-background': 'transparent' }}
        className='focus:outline-hidden z-10'
        tabIndex='0'
        ref={$svg}
      />
      {!readonly && value?.length != 0 && (
        <button
          className='text-base-600 hover:bg-base-300/25 focus-visible:outline-hidden focus-visible:ring-base-500 absolute right-2 top-2 z-10 h-8 rounded-md px-3 text-xs focus-visible:ring-2 focus-visible:ring-offset-2'
          onClick={clear}
        >
          Clear
        </button>
      )}
      <div className='text-base-500 border-base-150 absolute bottom-2 left-6 right-6 border-t-2 text-center'>
        Signature
      </div>
    </>
  );
}
